/**
 * Reading the backend's manning-stats text. Each entry is a "HHMM: counts" line,
 * followed by a line of per-zone counts.
 */

/** The distinct entry times, in order — the choices offered by the stats filter. */
export function statsTimeMarkers(stats: string | undefined): string[] {
  if (!stats) return [];
  const markers: string[] = [];
  const seen = new Set<string>();
  for (const line of stats.split('\n')) {
    const m = line.match(/^(\d{4}):/);
    if (m && !seen.has(m[1])) { seen.add(m[1]); markers.push(m[1]); }
  }
  return markers;
}

/** Every entry time, in order (repeats kept). */
export function statsMarkers(filteredStats: string): string[] {
  const markers: string[] = [];
  for (const line of filteredStats.split('\n')) {
    const m = line.match(/^(\d{4}):/);
    if (m) markers.push(m[1]);
  }
  return markers;
}

/** The on-the-hour entries, as columns for the counter graph's header. */
export function hourlyStats(stats: string): Array<{ time: string; counts: string; zones: string }> {
  if (!stats) return [];
  const result: Array<{ time: string; counts: string; zones: string }> = [];
  const lines = stats.split('\n');
  for (let i = 0; i < lines.length; i++) {
    const m = lines[i].match(/^(\d{4}):\s*(.*)/);
    if (m && m[1].slice(2) === '00') {
      result.push({ time: m[1], counts: m[2].trim(), zones: lines[i + 1]?.trim() ?? '' });
    }
  }
  return result;
}

/** Every entry with its zone line, :30 ones included — the per-zone bands under the grid. */
export function zoneStatEntries(graphStats: string): Array<{ time: string; zones: string }> {
  if (!graphStats) return [];
  const result: Array<{ time: string; zones: string }> = [];
  const lines = graphStats.split('\n');
  for (let i = 0; i < lines.length; i++) {
    const m = lines[i].match(/^(\d{4}):/);
    if (m) result.push({ time: m[1], zones: lines[i + 1]?.trim() ?? '' });
  }
  return result;
}
